import BillProduct from './BillProduct'

import {
  Container,
  Title,
  SubTitle,
  LabelRow
} from './styles'

export default function BillProductList ({
  bill,
  billProducts = [],
  professionals = [],
  enableEditting = true,
  hasEditPermission = true,
  hasDeletePermission = true,
  onEdit: handleEdit,
  onDelete: handleDelete
}) {

  return billProducts.length > 0 && (
    <Container>
      <Title>Produtos</Title>
      <LabelRow enableEditting={enableEditting}>
        <SubTitle>Nome</SubTitle>
        <SubTitle>Profissional</SubTitle>
        <SubTitle>Qtd</SubTitle>
        <SubTitle>Preço</SubTitle>
        <SubTitle>Comissão</SubTitle>
        {enableEditting && <SubTitle>Ações</SubTitle>}
      </LabelRow>
      {billProducts.map ((product, index) => (
        <BillProduct
          key={index}
          bill={bill}
          data={product}
          professionals={professionals}
          enableEditting={enableEditting}
          hasEditPermission={hasEditPermission} 
          hasDeletePermission={hasDeletePermission} 
          onEdit={handleEdit}
          onDelete={handleDelete}
        />
      ))}
    </Container>
  )
}
